/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ValidateQuizAnswersRequest } from '../../models/validate-quiz-answers-request';
import { ValidateQuizAnswersResponse } from '../../models/validate-quiz-answers-response';

export interface ValidateQuizAnswers$Params {
      body: ValidateQuizAnswersRequest
}

export function validateQuizAnswers(http: HttpClient, rootUrl: string, params: ValidateQuizAnswers$Params, context?: HttpContext): Observable<StrictHttpResponse<ValidateQuizAnswersResponse>> {
  const rb = new RequestBuilder(rootUrl, validateQuizAnswers.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ValidateQuizAnswersResponse>;
    })
  );
}

validateQuizAnswers.PATH = '/api/dummies/quiz';
